import React from 'react';
import PropTypes from 'prop-types';
import shouldUpdate from 'recompose/shouldUpdate';
import { Table,TableBody, TableRow,TableRowColumn } from 'material-ui/Table';
import DatagridCell from 'admin-on-rest/lib/mui/list/DatagridCell';

const DatagridFooter = ({ resource, children, ids, data, basePath, styles, rowStyle, options, rowOptions, ...rest }) => (
  
    <Table>
    <TableBody displayRowCheckbox={false} className="datagrid-body" {...rest} {...options}>
       <TableRow selectable={true} {...rowOptions}>
      {ids.length>0 ?
 <TableRowColumn style={{textAlign:'center',fontWeight: 800}}>
       <p>      <span>סה"כ בש"ח :</span>
       
        <span>{data[ids[0]].totalHafkadot.toLocaleString(undefined, {
                        style: 'currency',
                        currency: 'ILS',
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }) ||0}</span></p>
                         <p><span>סה"כ מספר עסקאות :</span>
        <span>{data[ids[0]].total ||0}</span></p>
        </TableRowColumn>
        :''
        }
</TableRow>
    </TableBody>
    </Table>
);

DatagridFooter.propTypes = {
    ids: PropTypes.arrayOf(PropTypes.any).isRequired,
    isLoading: PropTypes.bool,
    resource: PropTypes.string,
    data: PropTypes.object.isRequired,
    basePath: PropTypes.string,
    options: PropTypes.object,
    rowOptions: PropTypes.object,
    styles: PropTypes.object,
    rowStyle: PropTypes.func,
};

DatagridFooter.defaultProps = {
    data: {},
    ids: [],
};

const PureDatagridFooter = shouldUpdate((props, nextProps) => nextProps.isLoading === false)(DatagridFooter);

// trick material-ui Table into thinking this is one of the child type it supports
PureDatagridFooter.muiName = 'TableBody';

export default PureDatagridFooter;


// WEBPACK FOOTER //
// ./src/components/Hafkadot/DatagridFooter.js